$( function () {
  /**
   * 1. CONFIGURATION & ASSETS
   */
  const SVGS = {
    prev: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M13.2929 6.29297L7.58594 12L13.2929 17.707L14.7069 16.293L10.4139 12L14.7069 7.70697L13.2929 6.29297Z" fill="#4E77FC"/></svg>',
    next: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M9.70697 16.9496L15.414 11.2426L9.70697 5.53564L8.29297 6.94964L12.586 11.2426L8.29297 15.5356L9.70697 16.9496Z" fill="#4E77FC"/></svg>'
  }

  window.__gcse = {
    parsetags: 'onload',
    initializationCallback: function () {
      // Use a poll to ensure elements are ready regardless of network speed
      const pollGSE = setInterval( () => {
        const $input = $( 'input.gsc-input' )
        if ( $input.length ) {
          $('.site-header input.gsc-input').attr('placeholder', 'Find anything...');
          $('.search-section input.gsc-input').attr('placeholder', 'Search for answers…');
          $( '.gsc-search-button-v2' ).html( 'Search' )
          $( '.search-container' ).removeClass( 'hide' )
          clearInterval( pollGSE )
        }
      }, 100 )
    }
  }

  /**
   * 2. UTILITIES
   */
  const convertToSlug = ( text ) => {
    return ( text || '' ).toLowerCase().trim()
      .replace( /\s+/g, '-' )
      .replace( /[^\w-]+/g, '' )
      .replace( /--+/g, '-' )
  }

  function createNavBtn ( type, active, callback ) {
    const isNext = type === 'next'
    const $btn = $( '<div>', {
      class: `gsc-cursor-page custom-nav-btn ${ type }-btn ${ active ? '' : 'disabled' }`,
      html: isNext ? `Next ${ SVGS.next }` : `${ SVGS.prev } Prev`
    } )

    if ( active ) {
      $btn.on( 'click', ( e ) => {
        e.preventDefault()
        callback()
      } )
    }
    return $btn
  }

  /**
   * 3. PAGINATION LOGIC
   */
  function formatPagination ( $cursorBox ) {
    const $cursor = $cursorBox.find( '.gsc-cursor' )
    if ( !$cursor.length || $cursor.hasClass( 'pagination-rendered' ) ) return

    const $pages = $cursor.find( '.gsc-cursor-page' )
    if ( !$pages.length ) return

    const $currentPage = $cursor.find( '.gsc-cursor-current-page' )
    const currentIndex = $pages.index( $currentPage )
    const totalPages = $pages.length

    // Sliding window logic (4 pages)
    let start = Math.max( 0, currentIndex - 1 )
    let end = Math.min( totalPages - 1, start + 3 )
    if ( end === totalPages - 1 ) start = Math.max( 0, end - 3 )

    const $numberWrapper = $( '<div>', { class: 'gsc-cursor-number-wrapper' } )

    $pages.each( function ( i ) {
      if ( i >= start && i <= end ) {
        $( this ).css( 'display', 'inline-flex' ).appendTo( $numberWrapper )
      }
    } )

    // Reconstruct cursor
    $cursor.empty().addClass( 'pagination-rendered' )
      .append( createNavBtn( 'prev', currentIndex > 0, () => $pages[ currentIndex - 1 ].click() ) )
      .append( $numberWrapper )
      .append( createNavBtn( 'next', currentIndex < totalPages - 1 && currentIndex !== -1, () => $pages[ currentIndex + 1 ].click() ) )
  }

  /**
   * 4. MUTATION OBSERVER
   */
  let debounceTimer
  const mainObserver = new MutationObserver( () => {
    clearTimeout( debounceTimer )
    debounceTimer = setTimeout( () => {
      // A. Move Overlay
      const $overlay = $( '.gsc-results-wrapper-overlay' )
      if ( $overlay.length && !$overlay.parent().is( 'body' ) ) {
        $( 'body' ).append( $overlay )
      }

      // B. Handle Visible Results
      const $visibleOverlay = $( '.gsc-results-wrapper-visible' )
      if ( $visibleOverlay.length ) {
        // Add header only once
        if ( !$visibleOverlay.find( '.custom-results-header' ).length ) {
          $visibleOverlay.prepend( '<h2 class="custom-results-header">Search results</h2>' )
        }

        // Slugs for refinements
        $visibleOverlay.find( '.gsc-refinementHeader span' ).each( function () {
          const $span = $( this )
          const slug = convertToSlug( $span.text() )
          if ( slug && !$span.hasClass( slug ) ) $span.addClass( slug )
        } )
      }

      // C. Pagination
      const $cursorBox = $( '.gsc-cursor-box' )
      if ( $cursorBox.length ) {
        $cursorBox.each( function () { formatPagination( $( this ) ) } )
      }
    }, 50 ) // Small debounce to prevent layout thrashing

    const $activeRadio = $( '.refinements-filters input[name="refinement"]:checked' )
    const label = $activeRadio.val()

    $( '.gsc-refinementHeader:contains("' + label + '")' ).click()
  } )

  mainObserver.observe( document.documentElement, { childList: true, subtree: true } )

  /**
   * MAPPING CONFIGURATION
   * Defines which Google element goes into which local container.
   */
  const placementMap = [
    // { selector: '.gstl_50.gssb_c', target: '.search-form-container' },
    { selector: '.gstl_51.gssb_c', target: '.search-form-container' },
    { selector: '.gstl_52.gssb_c', target: '.search-container' }
  ]

  const repositionGoogleElements = () => {
    placementMap.forEach( item => {
      const $el = $( item.selector )
      if ( $el.length ) {
        console.log( 'Found Google element:', item.selector )
        const $target = $( item.target )
        if ( $target.length && !$el.parent().is( $target ) ) {
          $target.append( $el )
          console.log( 'Moved to:', item.target )
        }
      }
    } )
  }

  /**
   * MUTATION OBSERVER
   * Google injects these at the end of <body> dynamically.
   */
  const observer = new MutationObserver( ( mutations ) => {
    repositionGoogleElements()
  } )

  // Start observing the body for added nodes
  observer.observe( document.body, {
    childList: true,
    subtree: false
  } )

  // Run immediately in case they already exist
  repositionGoogleElements()
} )